import React from "react";
import { Button } from "Components/ReactstrapSlim";

import classes from "./PricingCard.module.scss";

interface PricingCardProps {
   title: string;
   description: string;
   actionText: string;
   link?: string;
   price?: string;
   priceText?: string;
   icon?: React.ReactNode;
   action?: () => void;
}

const PricingCard: React.FC<PricingCardProps> = ({
   title,
   description,
   actionText,
   price,
   priceText,
   link,
   children,
   icon,
   action = () => undefined,
}) => {
   return (
      <div className={classes.card}>
         <span className={classes.icon}>{icon}</span>
         <a className={classes.cardTitle} href={link}>{title}</a>
         <span className={classes.description}>{description}</span>
         <span className={classes.price}>{price}</span>
         <span className={classes.priceText}>{priceText}</span>
         <Button
            fluid
            color="primary"
            size="sm"
            className={classes.cardButton}
            onClick={action}
         >
            {actionText}
         </Button>
         <div className={classes.cardFeatures}>
            {children}
         </div>
      </div>
   );
};

export default PricingCard;
